<template>
    <div id="fake"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {
    window.EventBus.$on("page-loaded", () => {
      const domPreloader = document.getElementById("preloader");
      TweenMax.to(domPreloader, 0.8, {
        opacity: 0,
        onComplete: () => {
          TweenMax.set(domPreloader, { display: "none" });
        }
      });
    });
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Preloader.vue